export function isMobile() {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return width <= 768;
}

export function isTablet() {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return width > 768 && width <= 1026;
}

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)*[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function rgb2hex(rgb) {
    const color = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (color && color.length === 4)
        ? (`0${parseInt(color[1], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(color[2], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(color[3], 10).toString(16)}`).slice(-2) : '';
}

/** @description Strips query string and preceding tilda from url
 */
export function stripUrl(url) {
    const regex = /.*(?=\?)/;
    let urlNoParam = url;
    if (regex.test(url)) {
        urlNoParam = regex.exec(url)[0]; // eslint-disable-line prefer-destructuring
    }
    if (urlNoParam.charAt(0) === '~') {
        urlNoParam = urlNoParam.subst(1);
    }
    return urlNoParam;
}

export function getDeviceWidth() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

export function getDevicePixelRatio() {
    return window.devicePixelRatio;
}

export function appendLinkToHead(rel, href, id) {
    let link = document.querySelector(`#${id}`);
    if (link === null) {
        link = document.createElement('link');
        link.rel = rel;
        link.id = id;
        link.href = href;
        const head = document.querySelector('head');
        head.appendChild(link);
    }
    else {
        link.href = href;
    }
}

export function appendMetaTagToHead(name, content, id) {
    let meta = document.querySelector(`#${id}`);
    if (meta === null) {
        meta = document.createElement('meta');
        meta.name = name;
        meta.id = id;
        meta.content = content;
        const head = document.querySelector('head');
        head.appendChild(meta);
    }
    else {
        meta.name = name;
        meta.content = content;
    }
}

export function deleteLinkFromHead(id) {
    const link = document.querySelector(`#${id}`);
    if (!link) {
        return;
    }
    link.remove();
}

export function createCookie(name, value, expiryDate) {
    const date = new Date();
    const now = new Date();
    date.setTime(Date.parse(expiryDate));
    if (date <= now) {
        // session cookie
        document.cookie = `${name}=${value}; path=/`;
    }
    else {
        document.cookie = `${name}=${value}; expires=${date}; path=/`;
    }
}

export function createCookieWithDuration(name, value, duration) {
    const now = new Date();
    const newDate = new Date(now.getTime() + (duration * 1000));
    document.cookie = `${name}=${value}; expires=${newDate}; path=/`;
}

export function readCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export function eraseCookie(name) {
    createCookie(name, '', -1);
}

export function stringToBool(string){
    const dictionary = {
        True: true, False: false, true: true, false: false,
    };
    return dictionary[string] || false;
}

export function getHexBackgroundColor(element){
    return (function(rgb) {
        return '#' + (!rgb ? 'FFFFFF' : rgb2hex(rgb))
    })(getComputedStyle(element).getPropertyValue('background-color'));
}
